import { type Common } from '../common.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type PhoneNumberConfiguration,
  type PhoneNumberConfigurationPopulated,
  type UpdateValues,
} from '../models/phoneNumber/phoneNumberConfiguration.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/phone-number-configurations';
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PhoneNumberConfigurationPopulated>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAll(options: FindAllOptions): Promise<PhoneNumberConfigurationPopulated[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PhoneNumberConfigurationPopulated> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async updateDetails(
    id: string,
    values: Pick<UpdateValues, 'displayName'>
  ): Promise<PhoneNumberConfiguration> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/details`);
    return await this.common.patchJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<PhoneNumberConfiguration> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async create(values: CreateValues): Promise<PhoneNumberConfiguration> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }
}
